import 'css/src/components/public-pages/sections/HomeTextSection';

import React from 'react';

import { BUTTON_SIZES, PrimaryButton } from '../../common/ui/Button';

import { Urls } from 'js/src/client';

const HomeTextSection = React.memo(function HomeTextSection() {
    return (
        <div className="p-l5-16 p-l5-sm-48 section-2 pb-l5-48">
            <div className="container">
                <div className="row align-items-center mt-l5-48">
                    <div className="col-md-6">
                        <h2>Turn anything into video</h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            Start from blogs, PDFs, even just bullet points.
                            <br />
                            Create videos people actually want to watch. Just drop in your ideas and
                            we’ll bring them to life.
                        </p>
                        <PrimaryButton
                            size={BUTTON_SIZES.LG}
                            text="Try for free"
                            href={Urls.SIGNUP}
                            className="mt-l5-16"
                        />
                    </div>
                    <div className="col-md-6">
                        <video
                            className="m-l5-48 home-text-section-image"
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="none"
                        >
                            <source
                                src="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/videos/home_text_section/text-to-video.webm"
                                type="video/webm"
                            />
                        </video>
                    </div>
                </div>
                <div className="row align-items-center mt-l5-48">
                    <div className="col-md-6">
                        <img
                            src="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/videos/home_text_section/magicpalette.webp"
                            className="m-l5-48 home-text-section-image"
                            loading="lazy"
                            decoding="async"
                            alt="AI-powered, human inspired video creation"
                        />
                    </div>
                    <div className="col-md-6">
                        <h2>AI-powered, human inspired video creation</h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            On brand, on budget, and on time. Since 2017, Lumen5 has helped global
                            teams scale video without losing brand control. You get enterprise-ready
                            AI tools, smart automation, and dedicated Customer Success and Creative
                            Services to guide you at every step.
                        </p>
                        <PrimaryButton
                            size={BUTTON_SIZES.LG}
                            text="Lumen5 for Enterprise"
                            href="https://lumen5.com/enterprise/"
                            className="mt-l5-16"
                        />
                    </div>
                </div>
                <div className="row align-items-center my-l5-48">
                    <div className="col-md-6">
                        <h2>Create more without compromising creativity</h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            More videos shouldn’t mean more compromises.
                            <br /> Lumen5 makes it easy for your team to create fast,
                            <br />
                            on-brand content with built-in brand controls, smart AI automation, and
                            hands-on support every step of the way.
                        </p>
                        <PrimaryButton
                            size={BUTTON_SIZES.LG}
                            text="Request a demo"
                            href="https://lumen5.com/book-a-demo?utm_campaign=6880892-%5BMARKETING%5D%20Demo%20Request%20Form&utm_source=Website&utm_medium=header-menu"
                            className="mt-l5-16"
                        />
                    </div>
                    <div className="col-md-6">
                        <img
                            src="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/videos/home_text_section/onbrand.webp"
                            className="m-l5-48 home-text-section-image"
                            loading="lazy"
                            decoding="async"
                            alt="Create more without compromising creativity"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default HomeTextSection;
